import { render } from "./FormatText.vue?vue&type=template&id=32d36840"
import script from "./FormatText.vue?vue&type=script&lang=js"
export * from "./FormatText.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32d36840"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32d36840', __exports__)) {
    api.reload('32d36840', __exports__)
  }
  
  module.hot.accept("./FormatText.vue?vue&type=template&id=32d36840", () => {
    api.rerender('32d36840', render)
  })

}


export default __exports__